// extracted by mini-css-extract-plugin
export default {"container":"Auth_container__MGLkU","button":"Auth_button__Hpnqi","buttonF":"Auth_buttonF__Vo33k"};